import React, { createContext, useContext, useState } from "react";

type LoaderContextType = {
  showLoader: boolean;
  setShowLoader: React.Dispatch<React.SetStateAction<boolean>>;
};

const INITIAL_CONTEXT_STATE: LoaderContextType = {
  showLoader: false,
  setShowLoader: () => {},
};

export const LoaderContext = createContext(INITIAL_CONTEXT_STATE);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (context != undefined) {
    return context;
  } else {
    throw new Error("useLoader must be used within LoaderProvider");
  }
};

export const LoaderProvider = ({ children }: { children: JSX.Element }) => {
  const [showLoader, setShowLoader] = useState(false);

  return (
    <LoaderContext.Provider value={{ showLoader, setShowLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};
